/**
 * Gemeinsames Gerüst der vier View-Seiten: Titelzeile mit Ansichtsnamen, Einträgezahl und
 * Schaltflächen, darunter das Grid (REQ-21 §3).
 */

import type { ReactNode } from 'react';

import { GridRowCountProvider } from '@/components/grid/GridRowCountProvider';
import type { ChinaAppSysView } from '@/types/entities';

import { ViewPageHead } from './ViewPageHead';

export interface ViewPageFrameProps {
  view: ChinaAppSysView | null;
  /**
   * `view-grid-container` bei Container und Bestellposition, `view-grid-Receipt` bei Rechnung
   * und Rechnungszuordnung. Die zweite Klasse ist unstyled, gehört aber zum DOM.
   */
  gridClassName: 'view-grid-container' | 'view-grid-Receipt';
  toolbar: ReactNode;
  /** Das Grid der Seite. */
  children: ReactNode;
}

export function ViewPageFrame(props: ViewPageFrameProps) {
  return (
    <div className="view-page">
      {/* Die Einträgezahl der Titelzeile entsteht erst beim Laden im Grid und wird über den
          Kontext nach oben gereicht (REQ-21 §3). */}
      <GridRowCountProvider>
        <div>
          <ViewPageHead view={props.view} toolbar={props.toolbar} />
          <div className={props.gridClassName}>{props.children}</div>
        </div>
      </GridRowCountProvider>
    </div>
  );
}

export default ViewPageFrame;
